import { Modal } from '@lunary/ui-web/modal'
import { useState } from 'react'
import type { AdminReadingTopicDto } from '@lunary/api-client'
import dlg from '../../shared/ui/confirm-dialog.module.css'
import styles from './reading-topics.module.css'

type Props = {
  readonly open: boolean
  readonly topic: AdminReadingTopicDto | null
  readonly pending: boolean
  readonly error: string | null
  readonly onSubmit: (value: { slug: string; title: string; hint: string }) => void
  readonly onClose: () => void
}

const SLUG = /^[a-z][a-z0-9_]{1,31}$/

export function TopicDialog({ open, topic, pending, error, onSubmit, onClose }: Props) {
  const [wasOpen, setWasOpen] = useState(false)
  const [editing, setEditing] = useState<AdminReadingTopicDto | null>(null)
  const [slug, setSlug] = useState('')
  const [title, setTitle] = useState('')
  const [hint, setHint] = useState('')

  if (open !== wasOpen) {
    setWasOpen(open)
    if (open) {
      setEditing(topic)
      setSlug(topic?.slug ?? '')
      setTitle(topic?.title ?? '')
      setHint(topic?.hint ?? '')
    }
  }

  const valid = title.trim().length > 0 && (editing !== null || SLUG.test(slug))

  return (
    <Modal
      open={open}
      size="sm"
      title={editing ? 'Изменить тему' : 'Новая тема'}
      dismissible={!pending}
      onClose={onClose}
      onSubmit={(e) => {
        e.preventDefault()
        if (valid && !pending) onSubmit({ slug, title: title.trim(), hint: hint.trim() })
      }}
      footer={
        <>
          <button type="button" className="secondary" disabled={pending} onClick={onClose}>
            Отмена
          </button>
          <button type="submit" disabled={pending || !valid}>
            {pending ? 'Минуту…' : editing ? 'Сохранить' : 'Создать'}
          </button>
        </>
      }
    >
      <div className={styles.form}>
        <label className={dlg.field}>
          <span className="muted">Название</span>
          <input value={title} maxLength={60} onChange={(e) => setTitle(e.target.value)} />
        </label>
        <label className={dlg.field}>
          <span className="muted">Подсказка под названием</span>
          <input value={hint} maxLength={200} onChange={(e) => setHint(e.target.value)} />
        </label>
        <label className={dlg.field}>
          <span className="muted">{editing ? 'Код, не меняется' : 'Код латиницей, потом не меняется'}</span>
          <input
            className={styles.mono}
            value={slug}
            maxLength={32}
            readOnly={editing !== null}
            placeholder="study"
            onChange={(e) => setSlug(e.target.value.toLowerCase())}
          />
        </label>
        {!editing && <p className="muted">Новая тема создаётся выключенной: сначала проверьте, потом включите.</p>}
        {editing && <p className="muted">Старые разборы хранят код, поэтому переименование безопасно: название обновится и в них.</p>}
      </div>
      {error && (
        <p className="error-box" role="alert">
          {error}
        </p>
      )}
    </Modal>
  )
}
